<template>

 <b-row class="d-flex justify-content-center">

  


    <!-- Modalidade pix -->
    <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">Modalidade Boleto </h5>
    </b-col>

    <!-- Multa por atrazo -->
   <b-col md="3">
      <b-form-group>
        <label class="" >Multa por atraso (%)</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-form-checkbox
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input  />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group>
        <label class="" >Dias após atraso</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
        

          <b-form-select
            v-model="selected"
            :options="options"
        />
        </b-input-group>
      </b-form-group>
    </b-col>

    <!-- Juros Mensal -->

    <b-col md="6">
      <b-form-group>
        <label class="" >Juros mensal (%)</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-form-checkbox
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input  />
        </b-input-group>
      </b-form-group>
    </b-col>

      <!-- Modalidade pix -->
    <b-col cols="12" class="" >
      <h5 class="font-weight-semibold">Modalidade PIX </h5>
    </b-col>

    <!-- Multa por atrazo -->
   <b-col md="6">
      <b-form-group>
        <label class="" >Multa por atraso</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-form-checkbox
            disabled
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input disabled />
        </b-input-group>
      </b-form-group>
    </b-col>

    <!-- Juros Mensal -->
    <b-col md="6">
      <b-form-group>
        <label class="" >Juros mensal</label>
        <feather-icon

            icon="AlertCircleIcon"
            size="10"
            class="text-info ml-1"
            badge-classes="badge-info"
          />
        <b-input-group>
          <b-input-group-prepend  is-text>
            <b-form-checkbox
            disabled
              name="checkbox-input"
            />
          </b-input-group-prepend>
          <b-form-input disabled />
        </b-input-group>
      </b-form-group>
    </b-col>

    <div class="d-flex justify-content-center">

          <b-button variant="gradient-dark "
           v-if="!spiner"
            
             @click="SalvarEstabelecimento()"
            >
              Salvar
          </b-button>
       
          <b-button
          v-if="spiner"
              variant="gradient-dark"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Salvando
          </b-button>
          
        </div>
  

  </b-row>
</template>
<script>
import { VBPopover, BButton, BPopover, BFormSelect, BInputGroup, BFormInput, BInputGroupPrepend, BRow, BCol, BFormCheckbox, BFormRadio, BFormGroup} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
      BInputGroup, 
      BFormInput, 
      BInputGroupPrepend, 
      BRow, 
      BCol, 
      BFormCheckbox, 
      BFormRadio, 
      BFormGroup,
      BFormSelect,VBPopover, BButton, BPopover
  },
 
    data() {
        return {
            selected: null,
            spiner:false,
      options: [
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
      ],
      optionsPeriodo: [
        { value: 0, text: "Dispensar" },
        { value: 2, text: "Taxa mensal"}
      ],
        }
    },

    created() {
  
  },
  computed: {
    usuario() {
      return this.$store.state.login.usuario;
    },
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
    mensagem_alert() {
      return this.$store.state.configEmpresa.mensagem_alert;
    },
  },

  methods: {
  async  SalvarEstabelecimento(){
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>